konnyScript(function($){
  //KO71, KO72 사이즈가이드 팝업창
  $('.hyfsWrap .hyfsTit').click(function(){
    $('.hyfsWrap').toggleClass('on');
  });
  $('.hyfsWrap .hyfsBg').click(function(){
    $('.hyfsWrap').toggleClass('on');
  });
  $('.hyfsCon .hyfsX').click(function(){
    $('.hyfsWrap').toggleClass('on');
  });

  
  //KO285 모달 배앓이방지 내복 세트 사이즈표 아코디언 + 팝업
  if($('.knsgWrap').length > 0){
    var hyfsContent = $('.knsgWrap').parent('.product-block-custom-liquid');
    hyfsContent.addClass('knsg_accordion');
  }
  $('.knsgWrap .knsgTit').click(function(){
    $('.knsgWrap').toggleClass('on');
  });
  $('.knsgWrap .knsgBg').click(function(){
    $('.knsgWrap').toggleClass('on');
  });
  $('.knsgCon .knsgX').click(function(){
    $('.knsgWrap').toggleClass('on');
  });
});